import * as types from "../types";
import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.token;

const API_SECTION_DETAIL = types.API_BASE_URL + "section/detail";
const API_CONTENT_LIST = types.API_BASE_URL + "content/list";
const API_CONTENT_DETAIL = types.API_BASE_URL + "content/detail";
const API_QUIZ_LIST = types.API_BASE_URL + "quiz/list";
const API_QUIZ_DETAIL = types.API_BASE_URL + "quiz/detail";
const API_QUIZ_END = types.API_BASE_URL + "quiz/end";
const API_TRYOUT_DETAIL = types.API_BASE_URL + "tryout/detail";
const API_TRYOUT_START_PACKAGE = types.API_BASE_URL + "tryout/start-package";
const API_TRYOUT_END = types.API_BASE_URL + "tryout/end";
const API_TRYOUT_PACKAGE_END = types.API_BASE_URL + "tryout-package/end";
const API_TRYOUT_START = types.API_BASE_URL + "tryout/start";
const API_TRYOUT_RESULT = types.API_BASE_URL + "tryout/result";
const API_TRYOUT_HISTORY = types.API_BASE_URL + "tryout/history";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  [types.GET_SECTION_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_SECTION_DETAIL+ '/' + payload.id)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_SECTION, response.data.data);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_CONTENT_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_CONTENT_LIST, payload)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_CONTENT, response.data.data);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_CONTENT_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_CONTENT_DETAIL + "/" + payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_QUIZ_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_QUIZ_LIST, payload)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_QUIZ, response.data.data);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_QUIZ_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_QUIZ_DETAIL + "/" + payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.END_QUIZ]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_QUIZ_END, payload)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_QUIZ_RESULT, response.data.data);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_TRYOUT_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_TRYOUT_DETAIL + "/" + payload)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_TRYOUT, response.data.data);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.START_TRYOUT_PACKAGE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_TRYOUT_START_PACKAGE + "/" + payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.END_TRYOUT]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_TRYOUT_END, payload)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_TRYOUT_ONGOING, null);
            commit(types.MUTATE_TRYOUT_RESULT, response.data.data);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.END_TRYOUT_PACKAGE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_TRYOUT_PACKAGE_END, payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.START_TRYOUT]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(API_TRYOUT_START, payload)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_TRYOUT_ONGOING, response.data.data.id);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_TRYOUT_RESULT]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_TRYOUT_RESULT + "/" + payload)
        .then(response => {
          if (response.data.status == 200) {
            commit(types.MUTATE_TRYOUT_RESULT, response.data.data);
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.GET_TRYOUT_HISTORY]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(API_TRYOUT_HISTORY)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },

  [types.FORUM_SECTION_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "forum/list", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.FORUM_REPLY_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "forum/reply", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.FORUM_DETAIL]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "forum/detail", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data[0]);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.FORUM_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "forum/create", payload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.FORUM_REPLY]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post(types.API_BASE_URL + "forum/reply", payload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.NOTIF_LIST]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "notif/user/list", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
  [types.NOTIF_UNREAD]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .get(types.API_BASE_URL + "notif/user/unread", payload)
        .then(response => {
          if (response.data.status == 200) {
            resolve(response.data.data);
          } else {
            reject(response.data.messages);
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            commit(types.MUTATE_LOGOUT);
            reject(error.message);
          } else {
            reject(error.message);
          }
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
